// @flow

import React, { Fragment } from "react";
import { MapSearchContext } from "../MapSearchContainer";
import MarkerPopup from "../MarkerPopup";

const MarkersList = () => (
  <MapSearchContext.Consumer>
    {({ markers, translations }) => {
      const items = markers.map((marker, index) => (
        <MarkerPopup key={index} {...marker} translations={translations} />
      ));
      return <Fragment>{items}</Fragment>;
    }}
  </MapSearchContext.Consumer>
);

export default MarkersList;
